import React, { Component } from 'react'
import { connect } from 'react-redux'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import { Preloader } from '../../components/Chart/index'
import Multi from '../../components/Multi'
import debounce from 'lodash/debounce'
import './style.css'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'
import 'react-circular-progressbar/dist/styles.css'
import { getCookieType } from '../../lib/format-cookie-types'
import RoundBlueButton from '../../components/BorderButton/round-blue-button'
import Alert from 'react-s-alert'
import { RangeSelector } from '../revenue/range-selector'
import moment from 'moment'
import { formatNumber, getPercentage, numberWithCommas } from '../../lib/format-number'
import { dayStart, dayEnd, earlierDate } from '../../lib/format-date'
import { isAdmin } from '../../lib/check-user'
import ACLCheckPermission from '../../components/ACLCheckPermission'
import { Storage } from 'aws-amplify'


class Imports extends Component {
    debouncedFilter = null

    state = {
        size: 20,
        offset: 0,
        filter: '',
        sort: 'creation',
        sortOrder: 'desc',
        objectId: '',
        transactionId: '',
        events: [],
        loading: false,
        lastEvaluatedKey: null,
        range: {
            type: 'current',
            startDate: null,
            endDate: null
        },
        loadingDownload: {},

    }

    onFilterChange(target) {
        console.log('onFilterChange', target.value, this)
        let offset = 0
        this.setState({ events: [], offset: offset, filter: target.value, lastEvaluatedKey: null }, () => {
            this.debouncedFilter(
                target.value,
                this.state.size,
                offset,
                this.state.sort,
                this.state.sortOrder,
                this.state.objectId,
                this.state.transactionId,
                null,
                this.state.range
            )
        })
    }
    onLoadMore() {
        let lastEvaluatedKey = this.state.lastEvaluatedKey
        let offset = this.state.offset + this.state.size
        this.setState({ offset: offset, lastEvaluatedKey: null }, () => {
            this.loadEventUploadDetails(
                this.state.filter,
                this.state.size,
                offset,
                this.state.sort,
                this.state.sortOrder,
                this.state.objectId,
                this.state.transactionId,
                lastEvaluatedKey,
                this.state.range
            )
        })
    }

    componentDidMount() {
        let search = window.location.search
        let params = new URLSearchParams(search)

        if (params.get('transactionId') && params.get('transactionId') != '') {
            this.setState({ filter: params.get('transactionId') })
        }

        this.setState(
            {
                filter: params.get('filter') || params.get('transactionId') || ''
            },
            () => {
                this.loadEventUploadDetails(
                    this.state.filter,
                    this.state.size,
                    this.state.offset,
                    this.state.sort,
                    this.state.sortOrder,
                    this.state.objectId,
                    this.state.transactionId,
                    null,
                    this.state.range
                )
                this.debouncedFilter = debounce(this.loadEventUploadDetails, 1000)
            }
        )
    }

    // call api for fetching event details
    loadEventUploadDetails(
        filter = '',
        size = 10,
        offset = 0,
        sort = 'creation',
        sortOrder = 'asc',
        objectId = '',
        transactionId = '',
        lastEvaluatedKey = null,
        range = null
    ) {
        const { start, end } = this.findStartEnd(range)

        console.log('loadEventUploadDetails: ', filter, size, offset, sort, sortOrder, objectId, transactionId, lastEvaluatedKey)
        // first reset then load data
        this.setState({ loading: true }, () => {
            axios
                .get(
                    '/event/import?size=' +
                        size +
                        '&offset=' +
                        offset +
                        '&sort=' +
                        sort +
                        '&filter=' +
                        filter +
                        '&sortOrder=' +
                        sortOrder +
                        '&objectId=' +
                        objectId +
                        '&transactionId=' +
                        transactionId +
                        '&lastEvaluatedKey=' +
                        encodeURIComponent(JSON.stringify(lastEvaluatedKey)) +
                        '&startDate=' +
                        start +
                        '&endDate=' +
                        end
                )
                .then(response => {
                    let newEvents = response.data.body

                    let oldEvents = this.state.events
                    oldEvents = oldEvents.concat(newEvents)
                    let _lastEvaluatedKey = response.data.body && response.data.body.length > 0 ? response.data.body[0].lastEvaluatedKey : null
                    this.setState({ events: oldEvents, lastEvaluatedKey: _lastEvaluatedKey, loading: false })
                })
        })
    }

    getPercentage(num) {
        //return parseFloat(num).toFixed(2);
        let n = parseFloat(num).toFixed(0)
        if (n === 'NaN') return '0'
        return n > 100 ? 100 : n
    }

    getMatchrate(num) {
        let n = parseFloat(num).toFixed(0)
        if (n === 'NaN') return 'Low'
        if (n >= 75) return 'High'
        if (n <= 75 && n >= 35) return 'Good'
        return 'Low'
    }

    getFilesJoinStr(event) {
        let str =
            event.files &&
            Object.keys(event.files)
                .map(el => el.substring(el.lastIndexOf('/') + 1))
                .join(', ')

        // truncate long str
        if (str.length > 100) str = str.substring(0, 100) + '...'
        return str
    }
    getFilesJoinHtml(event) {
        let arr = [<h3>Files processed</h3>]
        Object.keys(event.files)
            //.map(el => el.substring(el.lastIndexOf('/') + 1))
            .map(el => arr.push(<li>{el}</li>))

        return arr
    }

    // Get job status as an HTML item
    getStatus(event) {
        if (event.done === 0 && event.todo === 0 && event.errors === 0) return { status: 'Pending', description: 'Total jobs: ' + event.done + ' of ' + event.todo }
        if (event.todo === 0 && event.done === 0 && event.errors > 0) return { status: 'Failed', description: 'There were some errors: ' + event.message  }
        if (event.done === 0 && event.errors > 0 && event.errors > event.todo) return { status: 'Failed', description: 'There were some errors: ' + event.message  }

        if (event.errors > 0) {
            // completed with some errors, but we have cloned back failures
            if (event.errors + event.done > event.todo) return { status: 'Completed', description: '' }

            // completed with errors
            if (event.errors + event.done >= event.todo) {
                return {
                    //status: 'Completed with errors',
                    status: 'Completed',
                    description: 'Total Jobs: ' + event.todo + ', Successful jobs: ' + event.done + ', Jobs with Errors: ' + event.errors
                }
            }

            // failed: all audiences have failed - we can have errors > todo when we got a fail in the splitter batch before running the file
            if (event.errors >= event.todo) return { status: 'Failed', description: 'Error Message: ' + event.message }
        } else {
            // completed
            if (event.done >= event.todo)
                return { status: 'Completed', description: '' }
        }

        // else retunr running status
        return { status: 'Running', description: 'Total jobs: ' + event.done + ' of ' + event.todo }
    }
    getStatusRender(event) {
        const html = []

        let summaryStatus = this.getStatus(event)
        console.log('summaryStatus:', summaryStatus)

        let uuid = event.txId + '_' + event.destination + '_' + new Date().getTime();
        if(summaryStatus.description !== ''){
            html.push(
                <ReactTooltip key={'summaryTooltip' + uuid} id={'summaryTooltip' + uuid} type="dark" effect="solid">
                    <h3>Status</h3>
                    <div>{summaryStatus.description}</div>
                </ReactTooltip>
            )
        }

        if (summaryStatus.status === 'Completed') {
            html.push(
                <span key={'summaryBadge' + uuid} data-tip data-for={'summaryTooltip' + uuid} className="badge badge-success">
                    {summaryStatus.status}
                </span>
            )
        } else if (summaryStatus.status === 'Completed with errors') {
            html.push(
                <span key={'summaryBadge' + uuid} data-tip data-for={'summaryTooltip' + uuid} className="badge badge-warning">
                    {summaryStatus.status}
                </span>
            )
        } else if (summaryStatus.status === 'Failed') {
            html.push(
                <span key={'summaryBadge' + uuid} data-tip data-for={'summaryTooltip' + uuid} className="badge badge-danger">
                    {summaryStatus.status}
                </span>
            )
        } else {
            html.push(
                <span key={'summaryBadge' + uuid} data-tip data-for={'summaryTooltip' + uuid} className="badge badge-secondary">
                    {summaryStatus.status}
                </span>
            )
        }

        return html
    }

    simpleUpload() {
        window.location.href = '/audiences/import?importBtn=true'
    }
    bulkUpload() {
        window.location.href = '/audiences/import-bulk'
    }
    optOutUpload() {
        window.location.href = '/audiences/import-optout'
    }

    rerunBatch(transactionId) {
        axios.get('/event/import/rerun/' + transactionId).then(response => {
            console.log('rerun response', response)
            Alert.success('Batch queued successfully!')
        })
    }

    findStartEnd(range) {
        let start, end

        switch (range.type) {
            case 'custom':
                start = dayStart(range.startDate).format('YYYY-MM-DD')
                end = earlierDate(dayEnd(range.endDate), moment()).format('YYYY-MM-DD')
                break
            case 'last':
                const month = moment().month()
                start = dayStart(
                    moment()
                        .month(month - 1)
                        .date(1)
                ).format('YYYY-MM-DD')
                end = dayEnd(moment().date(0)).format('YYYY-MM-DD')
                break
            case 'current':
            default:
                start = dayStart(moment().date(1)).format('YYYY-MM-DD')
                end = moment().format('YYYY-MM-DD')
                break
        }

        return { start, end }
    }

    handleRangeChange(newRange) {
        const oldRange = this.state.range

        if (newRange.type !== 'custom' && newRange.type === oldRange.type) return
        else if (newRange.type === 'custom' && newRange.startDate === oldRange.startDate && newRange.endDate === oldRange.endDate) return

        this.setState({ events: [], offset: 0, range: newRange }, () => {
            this.loadEventUploadDetails(
                this.state.filter,
                this.state.size,
                this.state.offset,
                this.state.sort,
                this.state.sortOrder,
                this.state.objectId,
                this.state.transactionId,
                null,
                newRange
            )
        })
    }

    /*
    getFile(fileKey, index) {
        let loadingDownload = this.state.loadingDownload
        loadingDownload["" + index] = true
        this.setState({loadingDownload: loadingDownload}, () => {
            Storage.get(fileKey, {level: 'public', download: true}).then(result => {
            console.log("download result SUCCESS: ", result)
            let mimeType = result.ContentType
    
            let fileName = fileKey.substring(fileKey.lastIndexOf('/') + 1)          
            try {
                let blob = new Blob([result.Body], {type: mimeType})
    
                //downloading the file depends on the browser
                //IE handles it differently than chrome/webkit
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName)
                } else {
                let objectUrl = URL.createObjectURL(blob);
                let link = document.createElement('a')
                link.href = objectUrl
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                }
            } catch (exc) {
                console.log("Save Blob method failed with the following exception.");
                console.log(exc);
            }
        }).finally(() => {
            loadingDownload["" + index] = false
            this.setState({loadingDownload: loadingDownload})
        })


        })
    }*/

    getDownloadLink(fileBucket, fileKey, index) {

        let loadingDownload = this.state.loadingDownload
        loadingDownload["" + index] = true
        this.setState({loadingDownload: loadingDownload}, () => {
                
            axios.get('/events/downloadurl?s3Bucket=' + fileBucket + '&s3Prefix=' + fileKey).then(response => {
                console.log('downloadurl response', response)
                window.open(response.data.body, '_blank')

            }).finally(() => {
                loadingDownload["" + index] = false
                this.setState({loadingDownload: loadingDownload})
            })

        })
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <Multi>
                        <div className="row">
                            <div className="col-12">
                                <WhiteBox>
                                    <div className="row">
                                        <div className="col">
                                            <h3>Filter events</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="add-segment add-segment--search-field">
                                                <input
                                                    className="form-control"
                                                    placeholder="Filter events..."
                                                    value={this.state.filter}
                                                    onChange={({ target }) => this.onFilterChange(target)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </WhiteBox>
                            </div>
                        </div>

                        {this.state.loading && this.state.events.length === 0 ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-lg-12">
                                    <WhiteBox customStyle={{ overflow: 'visible' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <h3 className="box-title">Import Events:</h3>
                                            <div style={{ flex: 1 }} />

                                            <div className="text-right">
                                                <ACLCheckPermission api="/upload_notification" method="POST">
                                                    <ReactTooltip id="simpleCreateBtnTooltip" type="dark" effect="solid">
                                                        <span>Single upload segments</span>
                                                    </ReactTooltip>
                                                    <button
                                                        data-tip
                                                        data-for="simpleCreateBtnTooltip"
                                                        className="border-button inlinebuttons"
                                                        onClick={this.simpleUpload}>
                                                        SINGLE IMPORT
                                                    </button>
                                                </ACLCheckPermission>
                                                &#160;
                                                <ACLCheckPermission api="/audience_bulk_upload" method="POST">
                                                    <ReactTooltip id="createBtnTooltip" type="dark" effect="solid">
                                                        <span>Bulk upload segments</span>
                                                    </ReactTooltip>
                                                    <button
                                                        data-tip
                                                        data-for="createBtnTooltip"
                                                        className="border-button inlinebuttons"
                                                        onClick={this.bulkUpload}>
                                                        BULK IMPORT
                                                    </button>
                                                </ACLCheckPermission>
                                                &#160;
                                                <ACLCheckPermission api="/upload_notification/opt_out" method="POST">
                                                    <ReactTooltip id="optoutBtnTooltip" type="dark" effect="solid">
                                                        <span>Opt Out segments</span>
                                                    </ReactTooltip>
                                                    <button
                                                        data-tip
                                                        data-for="optoutBtnTooltip"
                                                        className="border-button inlinebuttons"
                                                        onClick={this.optOutUpload}>
                                                        OPT OUT IMPORT
                                                    </button>
                                                </ACLCheckPermission>
                                            </div>
                                        </div>

                                        <RangeSelector maxDate={moment()} range={this.state.range} onChangeRange={range => this.handleRangeChange(range)} />

                                        {this.state.events.length > 0 && (
                                            <table className="segment-list segment-list--table">
                                                <thead>
                                                    <tr className="audience-list audience-list--header">
                                                        <th className="audience-list audience-list--audience pointer" style={{ width: '150px' }}>
                                                            Transaction Id
                                                            {this.state.sort === 'transactionId' && (
                                                                <i className={'fa fa-angle-' + (this.state.sortOrder === 'asc' ? 'up' : 'down')} />
                                                            )}
                                                        </th>
                                                        <th className="audience-list audience-list--size pointer">Upload Type</th>
                                                        <th className="audience-list audience-list--creation pointer">
                                                            Last Updated
                                                            {this.state.sort === 'creation' && (
                                                                <i className={'fa fa-angle-' + (this.state.sortOrder === 'asc' ? 'up' : 'down')} />
                                                            )}
                                                        </th>
                                                        <th className="audience-list audience-list--audience pointer">Filename</th>
                                                        <th className="audience-list audience-list--size pointer">Cookie Type</th>
                                                        <th className="audience-list audience-list--creation pointer"> Status</th>
                                                        <th style={{ width: '100px' }} className="audience-list audience-list--creation">
                                                            Matchrate
                                                        </th>
                                                        <th style={{ width: '50px' }} className="audience-list audience-list--creation">
                                                            Syncs
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.events.map((event, index) => (
                                                        <tr key={'row-data-' + event.txId} className={`audience-list audience-list--row`}>
                                                            <td className="audience-list audience-list--audience">
                                                                <div className="row">
                                                                    <div className="col-6">{event.txId}</div>
                                                                    {isAdmin() && (
                                                                        <div className="col-2">
                                                                            <RoundBlueButton
                                                                                style={{ marginLeft: '20px' }}
                                                                                icon={<i className="fa fa-refresh" />}
                                                                                type="button"
                                                                                data-toggle="collapse"
                                                                                onClick={() => this.rerunBatch(event.txId)}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="audience-list audience-list--size">
                                                                <div className="badge badge-primary">
                                                                    {event.uploadType != '' ? event.uploadType.replace('_', ' ') : 'BULK'}
                                                                </div>
                                                            </td>

                                                            <td className="audience-list audience-list--creation">
                                                                {new Date(event.creation).toLocaleString()}
                                                            </td>
                                                            <td
                                                                className="audience-list audience-list--audience"
                                                                style={{ maxWidth: '410px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                <ReactTooltip id={'filenameTooltip' + index} type="dark" effect="solid">
                                                                    <div>{event.s3Prefix && event.s3Prefix.substring(event.s3Prefix.lastIndexOf('/') + 1)}</div>
                                                                </ReactTooltip>
                                                                <ReactTooltip id={'filenameDownloadTooltip' + index} type="dark" effect="solid">
                                                                    <div>Download this file: {event.s3Prefix && event.s3Prefix.substring(event.s3Prefix.lastIndexOf('/') + 1)}</div>
                                                                </ReactTooltip>


                                                                <span style={{ cursor: 'pointer' }} >
                                                                    {/* requeues doesn't have a single file */}
                                                                    {!event.txId.startsWith("REQ") && (
                                                                        <span>

                                                                            {event.s3Bucket.indexOf("-eu") != -1 && (
                                                                                <span className="badge badge-primary">EU</span>
                                                                            )}
                                                                            {event.s3Bucket.indexOf("-eu") == -1 && (
                                                                                <span className="badge badge-primary">US</span>
                                                                            )}
                                                                            &#160;


                                                                            <a data-tip data-for={'filenameDownloadTooltip' + index} href="#" onClick={()=> {

                                                                                this.getDownloadLink(event.s3Bucket, event.s3Prefix, index)

                                                                                }}>
                                                                                    {event.s3Prefix && event.s3Prefix.substring(event.s3Prefix.lastIndexOf('/') + 1)}
                                                                            

                                                                            {this.state.loadingDownload[index] && (
                                                                                <span className="login-loading-wrapper">
                                                                                    <i className="fa fa-spin fa-spinner" />
                                                                                </span>
                                                                            )}
                                                                            
                                                                        </a>


    </span>                                                                     


                                                                    )}
                                                                    {event.txId.startsWith("REQ") && (
                                                                        <span data-tip data-for={'filenameTooltip' + index}>
                                                                            {event.s3Prefix && event.s3Prefix.substring(event.s3Prefix.lastIndexOf('/') + 1)}
                                                                        </span>
                                                                    )}
                                                                </span>


                                                            </td>

                                                            <td className="audience-list audience-list--size">
                                                                <div className="badge badge-primary">{getCookieType(event.idType)}</div>
                                                            </td>
                                                            <td className="audience-list audience-list--creation">{this.getStatusRender(event)}</td>

                                                            <td className="audience-list audience-list--creation" style={{ width: '130px' }}>
                                                                {event.idFound >= 0 && event.idMatched > 0 && (
                                                                    <div className="row" style={{}}>
                                                                        {/* use 'max-width' for setting size of the circular progressbar   */}

                                                                        <ReactTooltip id={'totalTooltip' + index} type="dark" effect="solid">
                                                                            <h3>FILE STATS</h3>
                                                                            <div>
                                                                                Matchrate: {this.getPercentage(event.idFound > 0 ? ((event.idMatched / event.idFound) * 100.0) : 100.0)}%
                                                                            </div>
                                                                            <div>Rows Matched: {numberWithCommas(event.idMatched)}</div>
                                                                            {event.idFound && event.idFound > 0 && (
                                                                                <div>Rows with this audience in file: {numberWithCommas(event.idFound)}</div>
                                                                            )}
                                                                            <div>Total Rows in file: {numberWithCommas(event.idFound > 0 ? event.idFound : event.idMatched  )}</div>
                                                                        </ReactTooltip>

                                                                        {/* total performance: matched / rows */}
                                                                        <div
                                                                            data-tip
                                                                            data-for={'totalTooltip' + index}
                                                                            className="col"
                                                                            style={{ maxWidth: '100px', cursor: 'pointer' }}>
                                                                            {/*
                                                                            <center style={{ top: '-10px', position: 'relative' }}>
                                                                                <font>
                                                                                    <b>AR:</b> {this.getPercentage((event.idMatched / event.idFound) * 100.0)}%
                                                                                </font>
                                                                                <ProgressBar
                                                                                    now={this.getPercentage((event.idMatched / event.idFound) * 100.0)}
                                                                                />
                                                                            </center>
                                                                            */}

                                                                            <div style={{ verticalAlign: 'middle', margin: '10px' }}>
                                                                                <b style={{ fontWeight: 'bold' }}>AR</b>

                                                                                {/*this.getPercentage((event.idMatched / event.idFound) * 100.0)}% */}
                                                                                <p style={{ fontSize: '16px' }}>
                                                                                    {this.getMatchrate( event.idFound > 0 ? ((event.idMatched / event.idFound) * 100.0) : 100.0 ) }

                                                                                    <span
                                                                                        className={
                                                                                            this.getMatchrate(event.idFound > 0 ? ((event.idMatched / event.idFound) * 100.0) : 100.0) ===
                                                                                            'High'
                                                                                                ? 'fa fa-angle-double-up'
                                                                                                : this.getMatchrate(
                                                                                                    event.idFound > 0 ? ((event.idMatched / event.idFound) * 100.0) : 100.0
                                                                                                  ) === 'Low'
                                                                                                ? 'fa fa-angle-down'
                                                                                                : 'fa fa-angle-up'
                                                                                        }
                                                                                        style={{
                                                                                            top: '2px',
                                                                                            position: 'relative',
                                                                                            left: '3px',
                                                                                            color:
                                                                                                this.getMatchrate(event.idFound > 0 ? ((event.idMatched / event.idFound) * 100.0) : 100.0 ) ===
                                                                                                'Low'
                                                                                                    ? '#ffc107'
                                                                                                    : '#27a745',
                                                                                            fontSize: '20px'
                                                                                        }}></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td className="audience-list audience-list--creation" style={{ width: '108px' }}>
                                                                <div className="row">
                                                                    <ReactTooltip id={'syncBtnTooltip' + index} type="dark" effect="solid">
                                                                        <span>Syncs</span>
                                                                    </ReactTooltip>
                                                                    <ReactTooltip id={'syncAudienceBtnTooltip' + index} type="dark" effect="solid">
                                                                        <span>Syncs Audiences Processed</span>
                                                                    </ReactTooltip>

                                                                    <div className="col">
                                                                        <a 
                                                                            onClick={() => {
                                                                                this.props.history.push({
                                                                                    pathname: '/syncs',
                                                                                    search: '?transactionId=' + event.txId,
                                                                                    state: { range: JSON.stringify(this.state.range) }
                                                                                })
                                                                            }}
                                                                        >
                                                                            <RoundBlueButton
                                                                                icon={<i className="fa fa-share" />}
                                                                                data-tip
                                                                                data-for={'syncBtnTooltip' + index}
                                                                                type="button"
                                                                                data-toggle="collapse"
                                                                                data-target={'/syncs?transactionId=' + event.txId}
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                    <div className="col">
                                                                        <a 
                                                                            onClick={() => {
                                                                                this.props.history.push({
                                                                                    pathname: '/syncs/audiences',
                                                                                    search: '?transactionId=' + event.txId,
                                                                                    state: { range: JSON.stringify(this.state.range) }
                                                                                })
                                                                            }}
                                                                        
                                                                        >
                                                                            <RoundBlueButton
                                                                                icon={<i className="fa fa-info" />}
                                                                                data-tip
                                                                                data-for={'syncAudienceBtnTooltip' + index}
                                                                                type="button"
                                                                                data-toggle="collapse"
                                                                                data-target={'/syncs/audiences?transactionId=' + event.txId}
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}

                                                    {this.state.loading && (
                                                        <tr>
                                                            <td colSpan={5} style={{ textAlign: 'center' }}>
                                                                <button
                                                                    type="button"
                                                                    disabled
                                                                    className="btn btn-link property-list property-list--load-more-button">
                                                                    Loading...
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {!this.state.loading &&  this.state.events.length >= this.state.offset + this.state.size  && (
                                                        <tr>
                                                            <td colSpan={5} style={{ textAlign: 'center' }}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link property-list property-list--load-more-button"
                                                                    onClick={this.onLoadMore.bind(this)}>
                                                                    Load more
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        )}

                                        {this.state.events.length == 0 && (
                                            <div className="empty-page">
                                                <h2 className="empty-page empty-page--title">No events found.</h2>
                                            </div>
                                        )}
                                    </WhiteBox>
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Imports)
